function seoLinks() {
  const group2 = document.getElementById('group-2');
  const group3 = document.getElementById('group-3');
  const seeMore = document.getElementById('see-more');
  const seeLess = document.getElementById('see-less');

	if (!(group2 && group3)) return;
	
  seeMore.addEventListener('click', () => {
    group2.classList.remove('hidden');
    group3.classList.remove('hidden');
    seeMore.classList.add('hidden');
    seeLess.classList.remove('hidden');
  });

  seeLess.addEventListener('click', () => {
    group2.classList.add('hidden');
    group3.classList.add('hidden');
    seeLess.classList.add('hidden');
    seeMore.classList.remove('hidden');
  });
};

document.addEventListener("DOMContentLoaded", seoLinks);
